import {
  useAudioOutputs,
  useLogger,
  useMeetingManager,
} from 'amazon-chime-sdk-component-library-react'
import { DeviceInput } from './DeviceInput'

type SpeakerSelectionProps = {
  /** The message that will be shown when no audio output speaker devices are found. */
  notFoundMsg?: string
  /** The label that will be shown for speaker selection, it defaults to `Speaker source`. */
  label?: string
  /** Optional description to help the user understand what they are selecting */
  description?: string
  /** The callback fired when the selection is changed.
   *  It is required if you want to add testing functionality around speaker selection. */
  onChange?: (selectedAudioOutputDevice: string) => void
}

export function SpeakerSelection({
  notFoundMsg = 'No speaker devices found',
  label = 'Speaker source',
  onChange,
  ...props
}: SpeakerSelectionProps) {
  const logger = useLogger()
  const { devices, selectedDevice } = useAudioOutputs()
  const meetingManager = useMeetingManager()

  const handleSelect = async (deviceId: string): Promise<void> => {
    try {
      await meetingManager.startAudioOutputDevice(deviceId)
      onChange?.(deviceId)
    } catch {
      logger.error('SpeakerSelection failed to select speaker')
    }
  }

  return (
    <DeviceInput
      {...props}
      devices={devices}
      label={label}
      notFoundMsg={notFoundMsg}
      selectedDevice={selectedDevice}
      onChange={handleSelect}
    />
  )
}
